"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _decorators = require("../utils/propTypes/decorators");

var Heading = (0, _styledComponents.default)(function (props) {
  var Tag = props.tagName,
      rest = (0, _objectWithoutProperties2.default)(props, ["tagName"]);
  return _react.default.createElement(Tag, rest);
}).withConfig({
  displayName: "Heading",
  componentId: "sc-9dtc71-0"
})([""]);
Heading.propTypes = {
  'aria-level': _propTypes.default.oneOf([1, 2, 3, 4, 5, 6]),
  tagName: (0, _decorators.hidden)(_propTypes.default.elementType.isRequired)
};
Heading.defaultProps = {
  'aria-level': 2,
  tagName: 'span'
};
var _default = Heading;
exports.default = _default;
module.exports = exports.default;